import { render } from "./DataPresensi.vue?vue&type=template&id=4a355a0c"
import script from "./DataPresensi.vue?vue&type=script&lang=js"
export * from "./DataPresensi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__